import React, { useEffect, useRef } from 'react';

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

const loadIntercom = () => {
  if (!INTERCOM_APP_ID) return;
  if (window.Intercom && window.Intercom.booted) return;
  window.intercomSettings = { app_id: INTERCOM_APP_ID };
  (function() {
    var w = window; var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator'); ic('update', w.intercomSettings);
    } else {
      var d = document; var i = function(){ i.c(arguments)}; i.q = []; i.c = function(args){ i.q.push(args)}; w.Intercom = i;
      var l = function(){ var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); };
      if (d.readyState === 'complete') { l(); }
      else if (w.attachEvent) { w.attachEvent('onload', l); }
      else { w.addEventListener('load', l, false); }
    }
  })();
};

const IntercomLoader = () => {
  const bootedRef = useRef(false);

  useEffect(() => {
    const shouldLoadFromConsent = () => {
      try {
        const saved = JSON.parse(localStorage.getItem('consent.v1'));
        return saved && (saved.analytics || saved.ads);
      } catch { return false; }
    };

    if (INTERCOM_APP_ID && shouldLoadFromConsent() && !bootedRef.current) {
      loadIntercom();
      bootedRef.current = true;
    }

    const onConsentUpdate = (e) => {
      const { analytics, ads } = (e && e.detail) || {};
      if ((analytics || ads) && !bootedRef.current) {
        loadIntercom();
        bootedRef.current = true;
      }
    };
    window.addEventListener('consent-updated', onConsentUpdate);
    return () => window.removeEventListener('consent-updated', onConsentUpdate);
  }, []);

  return null;
};

export default IntercomLoader;

